module.exports = __webpack_public_path__ + "img/customer.acafe06d.png";